import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
	withDestroyEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { TenantIndexResource } from "../../../../shared/types/tenant";
import {
	CompaniesBulkAttachRequest,
	CompanyCreateRequest,
	CountResource,
	ICompanyContact,
	ICompanyIndexResource,
	ICompanyOptionResource,
	ICompanyRequest,
	ICompanyUpdateResource,
} from "../types";
import { ArchiveByTenantRequest } from "../types/archive";

const baseKey = "companies";
const contactsByCompanyKey = (id: Id) => [baseKey, `${id}`, "contacts"];
const bulkAttachKey = [baseKey, "bulk-attach"];
const archivedKey = [baseKey, "archived"];

export const companyService = {
	index: (config: PaginatedListFetcherConfig<ICompanyIndexResource>) =>
		axios.get<LaravelResponse<ICompanyIndexResource[]>>(keyToUrl([baseKey]), {
			params: {
				...mapPaginatedFetcherConfigToAxiosConfig(config).params,
				orderBy: config.sortParams,
				filters: config.filterParams,
			},
		}),
	indexKey: [baseKey],
	indexArchived: (config: PaginatedListFetcherConfig<any>) =>
		axios.get<LaravelResponse<ICompanyIndexResource[]>>(keyToUrl(archivedKey), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, orderBy: config.sortParams },
		}),
	indexArchivedKey: archivedKey,
	getArchivedTenantsKey: (companyId: Id) => [baseKey, `${companyId}`, "archived-tenants"],
	getArchivedTenants: (companyId: Id) => {
		return axios.get<LaravelResponse<TenantIndexResource[]>>(keyToUrl([baseKey, `${companyId}`, "archived-tenants"]));
	},
	getTenantsKey: (companyId: Id) => [baseKey, `${companyId}`, "tenants"],
	getTenants: (companyId: Id) => {
		return axios.get<LaravelResponse<TenantIndexResource[]>>(keyToUrl([baseKey, `${companyId}`, "tenants"]));
	},
	archive: (companyId: Id, request: ArchiveByTenantRequest) =>
		axios.put(keyToUrl([baseKey, `${companyId}`, "archive"]), request),
	restore: (companyId: Id, request: ArchiveByTenantRequest) =>
		axios.put(keyToUrl([baseKey, `${companyId}`, "restore"]), request),
	listKey: [baseKey],
	...withShowEndpoint<ICompanyUpdateResource>([baseKey]),
	...withOptionsEndpoint<ICompanyOptionResource>([baseKey]),
	...withStoreEndpoint<CompanyCreateRequest>([baseKey]),
	...withUpdateEndpoint<ICompanyRequest>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	contactsByCompany: (id: Id, config: PaginatedListFetcherConfig<any>) => {
		return axios.get<LaravelResponse<ICompanyContact[]>>(
			keyToUrl(contactsByCompanyKey(id)),
			mapPaginatedFetcherConfigToAxiosConfig(config),
		);
	},
	contactsByCompanyKey,
	deleteAddress: (companyId: Id, addressId: Id) =>
		axios.delete(keyToUrl([baseKey, `${companyId}`, "addresses", `${addressId}`])),
	updateTags: (companyId: Id, tagIds: Id[]) => axios.put(keyToUrl([baseKey, `${companyId}`, "tags"]), { tagIds }),
	bulkAttachKey,
	bulkAttach: (request: CompaniesBulkAttachRequest) =>
		axios.put<LaravelResponse<CountResource>>(keyToUrl(bulkAttachKey), request),
};
